import useIsJapan from '@/hooks/use-is-japan'

const useIsDisplayQuotationRangeSelector = (
  isUnlimitedPlatform: boolean,
): boolean => {
  const isJapanWorkspace = useIsJapan()

  const shouldHideForJapanUnlimited = isJapanWorkspace && isUnlimitedPlatform

  return !shouldHideForJapanUnlimited
}

export default useIsDisplayQuotationRangeSelector
